import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-settings",
  templateUrl: "./med-icon-settings.component.html",
})
export class MedIconSettingsComponent extends SvgMixinComponent {}
